module.exports = __webpack_public_path__ + "img/community.49db183b.svg";